export {};

declare global {
  interface Window {
    $RefreshReg$: () => void;
    $RefreshSig$: <T>() => (type: T) => T;
  }
}

if (typeof window !== 'undefined') {
  window.$RefreshReg$ = () => {};
  window.$RefreshSig$ = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (type: any) => {
      return type;
    };
  };
}
